import { render, staticRenderFns } from "./LinkedActivity.vue?vue&type=template&id=496816dc&"
import script from "./LinkedActivity.vue?vue&type=script&lang=js&"
export * from "./LinkedActivity.vue?vue&type=script&lang=js&"
import style0 from "./LinkedActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports